"use strict";

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StandardContentTemplate = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _lodash = require("lodash");

var _gatsby = require("gatsby");

var _Jumbotron = _interopRequireDefault(require("../columns/Jumbotron"));

var _Columns = _interopRequireDefault(require("../main/Columns"));

var _Layout = _interopRequireDefault(require("./Layout"));

var StandardContentTemplate = function StandardContentTemplate(_ref) {
  var contents = _ref.contents,
      createDate = _ref.createDate,
      updateDate = _ref.updateDate,
      description = _ref.description,
      tags = _ref.tags,
      jumbotron = _ref.jumbotron,
      title = _ref.title,
      langKey = _ref.langKey,
      helmet = _ref.helmet,
      reusable = _ref.reusable,
      tagList = _ref.tagList,
      padding = _ref.padding;
  var today = (0, _moment["default"])().valueOf();
  var create = null;
  var update = null;

  if (createDate !== "" && createDate !== null) {
    create = (0, _moment["default"])(new Date(createDate)).format('YYYY.MM.DD');
  }

  if (updateDate !== "" && updateDate !== null) {
    update = (0, _moment["default"])(new Date(updateDate)).format('YYYY.MM.DD');
  }

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null, jumbotron &&
    /*#__PURE__*/
    _react["default"].createElement(_Jumbotron["default"], {
      data: jumbotron
    }),
    /*#__PURE__*/
    _react["default"].createElement("section", {
      className: "section",
      style: {
        padding: padding
      }
    }, helmet || '',
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "container content"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "columns"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "column is-10 is-offset-1"
    },
    /*#__PURE__*/
    _react["default"].createElement("h1", {
      className: "title is-size-7 has-text-weight-bold is-bold-light"
    }, title),
    /*#__PURE__*/
    _react["default"].createElement("p", {
      className: "is-size-15"
    }, create !== null && update !== null && create !== update &&
    /*#__PURE__*/
    _react["default"].createElement("b", null, "Created: ".concat(create), ' | ', "Last updated: ".concat(update)), create !== null && update !== null && create === update &&
    /*#__PURE__*/
    _react["default"].createElement("b", null, "Created: ".concat(create)), create === null && update !== null &&
    /*#__PURE__*/
    _react["default"].createElement("b", null, "Created: prior to 2018", ' | ', "Last updated: ".concat(update)), create !== null && update === null &&
    /*#__PURE__*/
    _react["default"].createElement("b", null, "Created: ".concat(create)), create === null && update === null &&
    /*#__PURE__*/
    _react["default"].createElement("b", null, "Created: prior to 2018")),
    /*#__PURE__*/
    _react["default"].createElement("p", null, description), contents && contents.length ?
    /*#__PURE__*/
    _react["default"].createElement("div", null, contents.map(function (content) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", null, content.startDate !== "" && content.startDate !== null && content.endDate !== "" && content.endDate !== null && today >= (0, _moment["default"])(new Date(content.startDate)).valueOf() && today <= (0, _moment["default"])(new Date(content.endDate)).valueOf() || content.startDate !== "" && content.startDate !== null && (content.endDate === "" || content.endDate === null) && today >= (0, _moment["default"])(new Date(content.startDate)).valueOf() || (content.startDate === "" || content.startDate === null) && content.endDate !== "" && content.endDate !== null && today <= (0, _moment["default"])(new Date(content.endDate)).valueOf() || (content.startDate === "" || content.startDate === null) && (content.endDate === "" || content.endDate === null) ?
        /*#__PURE__*/
        _react["default"].createElement(_Columns["default"], {
          content: content,
          langKey: langKey,
          reusable: reusable
        }) : null)
      );
    })) : null, tags && tags.length && tags.some(function (tag) {
      return Boolean(tag.value);
    }) ?
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement("h4", null, "Tags"),
    /*#__PURE__*/
    _react["default"].createElement("ul", {
      className: "taglist"
    }, tags.map(function (tag) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_react["default"].Fragment, null, tagList.frontmatter.tagList.map && tagList.frontmatter.tagList.map(function (tagList) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_react["default"].Fragment, null, (0, _lodash.toUpper)(tagList.tag) === (0, _lodash.toUpper)(tag.value) &&
            /*#__PURE__*/
            _react["default"].createElement("li", {
              key: tagList.tag + "tag"
            },
            /*#__PURE__*/
            _react["default"].createElement(_gatsby.Link, {
              to: "/".concat(tagList.tag, "/")
            }, tagList.tag)))
          );
        }))
      );
    }))) : null)))))
  );
};

exports.StandardContentTemplate = StandardContentTemplate;
StandardContentTemplate.propTypes = {
  contents: _propTypes["default"].node.isRequired,
  contentComponent: _propTypes["default"].func,
  createDate: _propTypes["default"].string,
  updateDate: _propTypes["default"].string,
  description: _propTypes["default"].string,
  jumbotron: _propTypes["default"].object,
  title: _propTypes["default"].string,
  langKey: _propTypes["default"].string,
  helmet: _propTypes["default"].object,
  reusable: _propTypes["default"].object,
  tagList: _propTypes["default"].object,
  padding: _propTypes["default"].string
};

var StandardContent = function StandardContent(_ref2) {
  var data = _ref2.data,
      padding = _ref2.padding;
  var post = data.markdownRemark;
  var tags = data.tagList;
  var reuse = data.reusable;
  reuse = reuse.edges;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_Layout["default"], {
      langKey: post.fields.langKey,
      slug: post.fields.pathSlug
    },
    /*#__PURE__*/
    _react["default"].createElement(StandardContentTemplate, {
      contents: post.frontmatter.contents,
      createDate: post.frontmatter.createDate,
      updateDate: post.frontmatter.updateDate,
      description: post.frontmatter.description,
      jumbotron: post.frontmatter.jumbotron,
      helmet:
      /*#__PURE__*/
      _react["default"].createElement(_reactHelmet["default"], {
        titleTemplate: "%s | Blog"
      },
      /*#__PURE__*/
      _react["default"].createElement("title", null, "".concat(post.frontmatter.title)),
      /*#__PURE__*/
      _react["default"].createElement("meta", {
        name: "description",
        content: "".concat(post.frontmatter.description)
      })),
      tags: post.frontmatter.tags,
      title: post.frontmatter.title,
      langKey: post.fields.langKey,
      reusable: reuse,
      tagList: tags,
      padding: padding
    }))
  );
};

StandardContent.propTypes = {
  data: _propTypes["default"].shape({
    markdownRemark: _propTypes["default"].object,
    reusable: _propTypes["default"].object,
    tagList: _propTypes["default"].object
  }),
  padding: _propTypes["default"].string
};
var _default = StandardContent;
exports["default"] = _default;